import { useState, useCallback } from 'react'

export function useShareLink() {
  const [copied, setCopied] = useState(false)

  // Toggle theme and persist preference
  const copyLink = useCallback(() => {
    const currentUrl = `${window.location.origin}${window.location.pathname}`
    navigator.clipboard.writeText(`${currentUrl}`)
    setCopied(true)

    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }, [])

  return { copied, copyLink }
}
